import api from 'core/api';
import { call, put } from 'redux-saga/effects';

export const newCompetitionsModule = 'newCompetitions';

const loadingStates = {
  start: { loading: true },
  error: { loading: false },
  success: { loading: false },
};
const loadingCouponStates = {
  start: { loadingCoupon: true },
  error: { loadingCoupon: false },
  success: { loadingCoupon: false },
};
const loadingCloneStates = {
  start: { loadingClone: true },
  error: { loadingClone: false },
  success: { loadingClone: false },
};
const loadingResultsStates = {
  start: { loadingResults: true },
  error: { loadingResults: false },
  success: { loadingResults: false },
};
const loadingDivisionsStates = {
  start: { loadingDivisions: true },
  error: { loadingDivisions: false },
  success: { loadingDivisions: false },
};
const loadingMyCompetitionsStates = {
  start: { loadingMyCompetitions: true },
  error: { loadingMyCompetitions: false },
  success: { loadingMyCompetitions: false },
};

const actions = {
  getMyCompetitions: {
    module: newCompetitionsModule,
    name: 'getMyCompetitions',
    api: () => api.get(`/competitions`),
    params: {
      start: ['params'],
      error: [''],
      success: [],
    },
    state: loadingMyCompetitionsStates,
  },
  getCompetitionResults: {
    module: newCompetitionsModule,
    name: 'getCompetitionResults',
    api: (params) => api.get(`/competitions/${params.competitionId}/results`, { params }),
    *sagas(Creators, { params, options }) {
      try {
        const resp = yield call(actions.getCompetitionResults.api, params);
        yield put(Creators.getCompetitionResultsSuccess(resp.pagination));
        if (options.onSuccess) {
          options.onSuccess(resp.data, resp.pagination);
        }
      } catch (error) {
        if (options.onError) {
          options.onError(error);
        }
        yield put(Creators.getCompetitionResultsError());
      }
    },
    params: {
      start: ['params'],
      error: [''],
      success: [],
    },
    state: loadingResultsStates,
  },
  cloneCompetition: {
    module: newCompetitionsModule,
    name: 'cloneCompetition',
    api: (data) => api.post(`/competitions/${data?.competitionId}/clone`, data),
    params: {
      start: ['params'],
      error: [''],
      success: [],
    },
    state: loadingCloneStates,
  },
  getCompetitionDivisions: {
    module: newCompetitionsModule,
    name: 'getCompetitionDivisions',
    api: ({ competitionId }) => api.get(`/competitions/${competitionId}/divisions`),
    params: {
      start: ['params'],
      error: [''],
      success: [],
    },
    state: loadingDivisionsStates,
  },
  getCompetitionPayments: {
    module: newCompetitionsModule,
    name: 'getCompetitionPayments',
    api: (params) => api.get(`/competitions/${params?.competitionId}/payments`, { params }),
    params: {
      start: ['params'],
      error: [''],
      success: [],
    },
    state: loadingStates,
  },
  getRegistrationPrice: {
    module: newCompetitionsModule,
    name: 'getRegistrationPrice',
    api: (params) => api.post(`/competitions/${params?.competitionId}/resume_registration`, params),
    params: {
      start: ['params'],
      error: [''],
      success: [],
    },
    state: loadingStates,
  },
  getCompetitionsShowUser: {
    module: newCompetitionsModule,
    name: 'getCompetitionsShowUser',
    api: (params) => api.get(`/competitions/${params.competitionId}/users/show/${params?.userId}`),
    params: {
      start: ['params'],
      error: [''],
      success: [],
    },
    state: loadingStates,
  },

  connectStripeAccount: {
    module: newCompetitionsModule,
    name: 'connectStripeAccount',
    api: ({ competitionId, code }) =>
      api.get(`/competitions/${competitionId}/connect_stripe_account/${code}`),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingStates,
  },
  removeStripeAccount: {
    module: newCompetitionsModule,
    name: 'removeStripeAccount',
    api: ({ competitionId }) => api.delete(`/competitions/${competitionId}/remove_stripe_account`),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingStates,
  },
  getDiscount: {
    module: newCompetitionsModule,
    name: 'getDiscount',
    api: ({ competitionId, code }) => api.get(`/competitions/${competitionId}/coupon/${code}`),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingCouponStates,
  },
};

export default {
  actions,
  state: {
    loading: false,
    loadingCoupon: false,
    loadingResults: false,
    loadingDivisions: false,
    users: [],
    pagination: null,
  },
};
